<template>
  <v-container>
    <v-layout
      row
      pt-10
    >
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <h2
          class="primary--text"
        >
          Add a Ballet Class to the Schedule
        </h2>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex
        xs12
      >
        <form @submit.prevent="onCreateBalletClass">
          <v-layout
            row
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-text-field
                id="title"
                v-model="title"
                name="title"
                label="Title"
                required
              />
              <v-text-field
                id="ballet-class-description"
                v-model="balletClassDescription"
                item-value="db"
                name="balletClassDescription"
                label="Description / Details"
                required
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <h3>
                Choose a Date
              </h3>
            </v-flex>
          </v-layout>
          <v-layout
            row
            pt-3
          >
            <v-flex
              offset-sm3
            >
              <v-date-picker
                v-model="date"
                required
              />
            </v-flex>
          </v-layout>
          <v-row
            justify="space-around"
            align="center"
          >
            <v-col style="width: 350px; flex: 0 1 auto;">
              <h2>Start:</h2>
              <v-time-picker
                v-model="start"
                required
              ></v-time-picker>
            </v-col>
            <v-col style="width: 350px; flex: 0 1 auto;">
              <h2>End:</h2>
              <v-time-picker
                v-model="end"
                required
              ></v-time-picker>
            </v-col>
          </v-row>
          <v-layout
            row
            pt-5
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-btn
                class="primary"
                :disabled="!formIsValid"
                type="submit"
              >
                Create Class & Add Another
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  const moment = require('moment')
  export default {
    data () {
      return {
        title: '',
        balletClassPointe: '',
        balletClassPacing: '',
        balletClassDescription: '',
        date: '',
        start: '',
        end: '',
        tags: '',
        pointe: ['Y', 'N'],
        pacing: [
          { db: 'follow-along', text: 'Follow-along. No (or minimal) choreography or counts, simply follow-along.' },
          { db: 'conditioning', text: 'Conditioning follow-along. Quick explanation of exercise, then away we go!' },
          { db: 'slow', text: 'Slow. Lots of explanations and details.' },
          { db: 'moderate', text: 'Moderate. Moderate pace with occasional explanations for particularly tricky combos and concepts.' },
          { db: 'express', text: 'Express. Minimal explanations and very short breaks between combinations. Mostly dancing with very little instruction. Great for practicing picking up combinations quickly, memorization, and practice applying corrections on your own.' },
          { db: 'lecture', text: 'Lecture. Sit, watch, learn, and ask questions.' }
        ],
        descriptions: [
          { db: 'jumps', text: 'Jumps are not recommended if you have ceramic tile or concrete flooring. For wood flooring, jumps can be lower impact by wearing jazz sneakers.' },
          { db: 'upper-back', text: 'Must be comfortable lying on stomach & no active shoulder injuries.' },
          { db: 'happy-knees', text: 'Recommended pain-free knee joints and able to execute a fondu on a single leg without pain.' },
          { db: 'pbt-large-band', text: 'Using large exercise ball & theraband of any length.' },
          { db: 'pbt-ball-level-2', text: 'Using large exercise ball. Recommended familiar with PBT bridge technique.' },
          { db: 'pbt-balls', text: 'Using large exercise ball & small fusion ball' },
          { db: 'wrist-weight-bearing-yes', text: 'Will be weight-bearing on wrist & shoulder.' },
          { db: 'wrist-weight-bearing-no', text: 'No weight-bearing on wrist or shoulder.' },
          { db: 'arrive-warmed-up', text: 'Please arrive warmed up' },
          { db: 'rel-passe-center', text: 'Recommended comfortable with rélevé passé in center.' },
          { db: 'tricky', text: 'Bring a big smile and be ready for brain teasers!' },
          { db: 'basics', text: ' Great for slow methodical technique practice, whether you\'re still learning the movements or working to refine your technique.' },
          { db: 'pointe-level-2', text: 'Recommended graduated 16-week pointe cohort or equivalent: Able to do scoop sous-sus, échappé, rélevé passé, single leg rélevé, pas de bourrée, piqué ballonné.' },
          { db: 'int-pointe-class', text: 'Recommended comfortable (or willing to try without significant instruction) with more complex pointe combos at barre and in center.' },
          { db: 'int-pointe-center', text: 'Recommended comfortable (or willing to try without significant instruction) with tombé pas de bourrée, échappé 2nd & 4th, rélevé passé, soutenu in center.' },
          { db: 'low-chair', text: 'Must arrive warmed up. Have a low chair handy to put your leg on.' },
          { db: 'flexibility-splits-level', text: 'Must arrive thoroughly warmed up. Recommended able to touch toes & weight bear on wrists. If far from splits, 2 yoga blocks will make it much more comfortable and effective.' },
          { db: 'artistry', text: 'Feel like a dancer with beautiful barre combinations focused on musicality, breathing, and expression.' },
          { db: 'artistry-barre', text: 'Feel like a dancer with beautiful barre combinations focused on musicality, breathing, and expression.' },
          { db: 'artistry-center', text: 'Feel like a dancer and express yourself with gentle movement with beautiful and heartfelt port de bras.' },
          { db: 'advanced-pirouettes', text: 'Recommended comfortable with single pirouettes en dehors & en dedans & ready for more.' },
          { db: 'beginner-pirouettes', text: 'Strengthen for learning your first pirouette or refine your technique to move up to multiple turns.' },
          { db: 'bare-feet', text: 'Recommended bare feet.' },
          { db: 'masterclass', text: 'Come and watch, ask questions, and learn! If YOU want to be the one, email hello@brocheballet.com with subject line "PICK ME!" and email body which session you plan to attend. Dancers will be drawn at random!' },
          { db: 'pointe-flat', text: 'Pointe dancers may join at barre or in center. Designed for pointe shoes, but may join in ballet slippers.' },
          { db: 'beginner-turns', text: 'Understanding basic mechanics of turning. This class is designed for people without any turning experience.' },
          { db: 'jumps-level', text: 'Must be comfortable and pain-free with single-leg plié/fondu holding onto barre.' },
          { db: 'floor-barre', text: 'If you\'ve never tried floor barre before, give it a try! You might find yourself hooked on this incredible way to build strength, technique, and refine the details. ;) Preview the class by searching "kniaseff" in the Technique Library.' },
          { db: 'beginner-variations', text: 'Variation great for beginner ballet dancers.' }
        ]
      }
    },
    computed: {
      formIsValid () {
        console.log('computing')
        return this.title !== '' && this.start !== '' && this.end !== ''
      }
    },
    methods: {
      onCreateBalletClass () {
        if (!this.formIsValid) {
          return
        }
        var startTime = moment(this.date).set({
          hour: this.start.match(/(\d+):(\d+)/)[1],
          minute: this.start.match(/(\d+):(\d+)/)[2]
        }).toDate()
        var endTime = moment(this.date).set({
          hour: this.end.match(/(\d+):(\d+)/)[1],
          minute: this.end.match(/(\d+):(\d+)/)[2]
        }).toDate()
        const balletClassData = {
          title: this.title,
          pointe: this.balletClassPointe,
          pacing: this.balletClassPacing,
          description: this.balletClassDescription,
          startDate: startTime,
          endDate: endTime,
          tags: this.tags
        }
        this.$store.dispatch('createBalletClass', balletClassData)
        this.title = ''
        this.balletClassPointe = ''
        this.balletClassPacing = ''
        this.balletClassDescription = ''
        this.date = ''
        this.start = ''
        this.end = ''
        this.tags = ''
      }
    }
  }
</script>
